import React, { useEffect, useRef, useState } from "react";
import {
  HStack,
  Image,
  Stack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { createDataObject, totalFilterCount, updateFacetsData } from "../../../util/helper";
import GridView from "./Archive/GridView";
import * as getSearchArchiveData from "../../../services/Search";

const IMAGE_BASE_PATH = process.env.REACT_APP_DEV_IMAGE_BASE_PATH;
const loaderImg = `${IMAGE_BASE_PATH}/ui/Chevron/loader.gif`;

export const Archive = ({
  SearchTerm,
  setArchiveCount,
  masterlistType="search",
  filterbuttonStyle,
  onSortDataChange
}) => {
  const [showFilterBox, setShowFilterBox] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterOptions, setFilterOptions] = useState({ search: "", filters: {}, sortBy_v: "sortable_year",gate:"AND" });
  const [apply, setApply] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [filterCount, setFilterCount] = useState(0);
  const [triggerFetch, setTriggerFetch] = useState(false);
  const [filterPills, setFilterPills] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredResultCount, setFilteredResultCount] = useState(0);
  const [reset, setReset] = useState(false);

  const initialLoadComplete = useRef(false);
  const navigate = useNavigate();

  const handleFilterClick = () => {
    setShowFilterBox(!showFilterBox);
  };

  const handleItemNavigation = (item) => {
    navigate(`/archive/${item?.alias}`);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    handleCheckboxChange("searches", e.target.value)
  };

  const handleCheckboxChange = (value, type) => {
    let selectedArray = [];
    let selectedString = "";

    switch (value) {
      case "sort":
        selectedString = filterOptions.sortBy_v;
        break;
        case "gate":
          selectedString = filterOptions.gate;
          break;
      case "searches":
        selectedString = filterOptions.search;
        break;
      default:
        if (value in filterOptions.filters) {
          selectedArray = filterOptions.filters[value];
        }
        break;
    }

    if (Array.isArray(type)) {
      // Bulk replace (used by FilterBody's "Select All" / clear-all toggle)
      // rather than the usual single-value toggle below.
      selectedArray = type;
    } else if (selectedArray.includes(type)) {
      selectedArray = selectedArray.filter((checkbox) => checkbox !== type);
    } else {
      selectedArray = [...selectedArray, type];
    }

    if (selectedString !== type) {
      selectedString = type;
    }

    switch (value) {
      case "sort":
        setFilterOptions(prevFilterOptions => ({
          ...prevFilterOptions,
          sortBy_v: selectedString,
        }));
        break;
        case "gate":
          setFilterOptions(prevFilterOptions => ({
            ...prevFilterOptions,
            gate: selectedString,
          }));
          break;
      case "searches":
        setFilterOptions(prevFilterOptions => ({
          ...prevFilterOptions,
          search: selectedString,
        }));
        break;
      default:
        if (value in filterOptions.filters) {
          setFilterOptions(prevFilterOptions => ({
            ...prevFilterOptions,
            filters: {
              ...prevFilterOptions.filters,
              [value]: selectedArray,
            },
          }));
        }
        break;
    }
  };

  const citationFactor = (data) => {
    return data.map((item, index) => {
      const title = createDataObject([item?.find((nestedItem) => nestedItem?.key === "title") ]);
      const medium = createDataObject([item?.find((nestedItem) => nestedItem?.key === "medium_artwork") ]);
      const lot_number = createDataObject([item?.find((nestedItem) => nestedItem?.key === "lot_number") ]);
      const auction_house = createDataObject([item?.find((nestedItem) => nestedItem?.key === "auction_house_name") ]);
      const venue_location = createDataObject([item?.find((nestedItem) => nestedItem?.key === "venue") ]);
      const date_of_auction = createDataObject([item?.find((nestedItem) => nestedItem?.key === "auction_year_of_event") ]);
      const type_of_auction = createDataObject([item?.find((nestedItem) => nestedItem?.key === "type_of_auction") ]);

      const number_of_bids_received = createDataObject([item?.number_of_bids_received]);
      const percentage_over_under_mid_estimate = createDataObject([item?.percentage_over_under_mid_estimate]);
      const artwork_square_inch_rate = createDataObject([item?.artwork_square_inch_rate]);
      const previous_auction_sales = createDataObject([item?.previous_auction_sales]);
      const cagr_based_on_previous_sale = createDataObject([item?.cagr_based_on_previous_sale]);
      const size = createDataObject([item?.size]);

      const imagePath = item?.find((nestedItem) => nestedItem?.key === "direct_url_of_cover_image")?.value || item?.find((nestedItem) => nestedItem?.key === "direct_url_of_preview_image")?.value || "";
      const desc = item?.find((nestedItem) => nestedItem?.key === "bibliographic_citation")?.value || item?.find((nestedItem) => nestedItem?.key === "bibliograhpic_citation")?.value || "";
      const listDesc = item?.find((nestedItem) => nestedItem?.key === "bibliographic_caption")?.value || item?.find((nestedItem) => nestedItem?.key === "bibliograhpic_caption")?.value || "";
      
      return {
        image: imagePath,
        imagePath: imagePath,
        title: desc,
        desc: desc,
        listDesc: listDesc,
        publicationYear: item?.find((nestedItem) => nestedItem?.key === "sortable_year")?.value!=='0'?item?.find((nestedItem) => nestedItem?.key === "sortable_year")?.value : "n.d" || "n.d",
        imagedesc: item?.find((nestedItem) => nestedItem?.key === "bibliographic_caption")?.value || "",
        alias: item?.find((nestedItem) => nestedItem?.key === "alias")?.value,
        index: index,
        fullImageTitle: listDesc,
        masterlist_alias: item?.find((nestedItem) => nestedItem?.key === "masterlist_alias")?.value,
        essayistData: [title, medium, lot_number, auction_house, venue_location, date_of_auction, type_of_auction, size],
        auctionData: [number_of_bids_received, percentage_over_under_mid_estimate, artwork_square_inch_rate, previous_auction_sales, cagr_based_on_previous_sale],
      }
    });
  };

  const [facets, setFacets] = useState([]);
  const [sort, setSort] = useState([]);

  async function fetchData() {
    if (!SearchTerm) {
      setIsLoading(false);
      return;
    }
    
    try {
      setIsLoading(true);
      const result = await getSearchArchiveData.searchResearchArchiveTab(SearchTerm, filterOptions, 1);
      setIsLoading(false);
      if (result) {
        // Set facets regardless of whether there's data
        if (result?.facetsHeaders && result?.facets) {
          const formattedFacets = updateFacetsData({ data: result });
          setFacets(formattedFacets);
        
          if (formattedFacets && formattedFacets.length > 0) {
            setFilterOptions((prevFilterOptions) => ({
              ...prevFilterOptions,
              filters: {
                ...prevFilterOptions.filters,
                ...formattedFacets.reduce((acc, facet) => {
                  acc[facet.key] = [];
                  return acc;
                }, {}),
              },
            }));
          }
        }

        // Set sort options
        const sortedFacets = result?.sortByHeader?.map(obj => {
          const key = Object.keys(obj)[0];
          return { key: key, display: obj[key] };
        }) || [];
        setSort(sortedFacets);

        if (result?.data && result?.data.length > 0) {
          const processedData = citationFactor(result?.data);
          setData(processedData);
          if (!initialLoadComplete.current) {
            setPage(page + 1);
            initialLoadComplete.current = true;
          }
          setArchiveCount(result?.total || 0)
          if (result.total === result?.data.length) {
            setHasMore(false)
          }
        } else {
          setData([])
          setArchiveCount(result?.total || 0)
        }
      } else {
        setData([])
        setArchiveCount(0)
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading(false);
    }
  }

  const handleResetPage=()=>{
    initialLoadComplete.current = false;
    setHasMore(true);
    setPage(1);
    setTriggerFetch(prev => !prev);
  }

  useEffect(() => {
    if (SearchTerm) {
      handleResetPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SearchTerm]);

  // Register functions immediately when component mounts or SearchTerm changes
  useEffect(() => {
    if (onSortDataChange && SearchTerm) {
      onSortDataChange({
        sort: sort,
        filterOptions: filterOptions,
        handleCheckboxChange: handleCheckboxChange,
        setApply: setApply,
        masterlistType: masterlistType,
        hasData: data && data.length > 0,
        showFilterBox,
        handleFilterClick,
        filterAvailable: facets && facets.length > 0
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SearchTerm, showFilterBox]);

  useEffect(() => {
    if (SearchTerm) {
      fetchData();
      setFilterPills(filterOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerFetch, SearchTerm]);

  const fetchMoreData = async () => {
    try {
      const result = await getSearchArchiveData.searchResearchArchiveTab(SearchTerm, filterOptions, page);

      if (result) {
        const processedData = citationFactor(result?.data);
        setData(prevData => [...prevData, ...processedData]);
        setPage(page + 1);
        const sortedFacets = result?.sortByHeader?.map(obj => {
          const key = Object.keys(obj)[0];
          return { key: key, display: obj[key] };
        });
        setSort(sortedFacets);
        if (data?.length >= result?.total){
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  async function fetchFilterData(page=1) {
    try {
      setIsLoading(true);
      const result = await getSearchArchiveData.searchResearchArchiveTab(SearchTerm, filterOptions, page);
      setIsLoading(false);
      if (result) {
        // Update facets when filters are applied
        if (result?.facetsHeaders && result?.facets) {
          const formattedFacets = updateFacetsData({ data: result });
          setFacets(formattedFacets);
          if (formattedFacets && formattedFacets.length > 0 && reset) {
            setFilterOptions((prevFilterOptions) => ({
              ...prevFilterOptions,
              filters: {
                ...prevFilterOptions.filters,
                ...formattedFacets.reduce((acc, facet) => {
                  acc[facet.key] = [];
                  return acc;
                }, {}),
              },
            }));
            setReset(false);
          }
        }

        // Update sort options
        const sortedFacets = result?.sortByHeader?.map(obj => {
          const key = Object.keys(obj)[0];
          return { key: key, display: obj[key] };
        }) || [];
        setSort(sortedFacets);

        // Handle data
        const processedData = citationFactor(result?.data || []);
        setData(processedData);
        setPage(prev=>prev+1)
        
        const filtercnt= totalFilterCount(filterOptions?.filters)
        if(filtercnt>0 || filterOptions?.search){
          setFilteredResultCount(result?.total || 0)
        }else{
          setFilteredResultCount(0);
        }
        if ((result?.data?.length || 0) >= (result?.total || 0)) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (apply) {
      if(masterlistType==="search"){
        window.scrollTo(0, 0);
      }
      setApply(false);
      setHasMore(true);
      setPage(1)
      fetchFilterData();
      setFilterPills(filterOptions)
    }
    const filtercnt= totalFilterCount(filterOptions?.filters)
    setFilterCount(filtercnt)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apply]);

  const handleReset = () => {
    setFilteredResultCount(0);
    const initializedFilters = facets.reduce((acc, facet) => {
      acc[facet.key] = [];
      return acc;
    }, {});
    setFilterOptions({
      search: "",
      filters: initializedFilters,
      sortBy_v: "sortable_year",gate:"AND"
    });
    setFilterCount(0)
    setSearchTerm("");
    setReset(true);
  }

  useEffect(() => {
    if (onSortDataChange) {
      onSortDataChange({
        sort: sort,
        filterOptions: filterOptions,
        handleCheckboxChange: handleCheckboxChange,
        setApply: setApply,
        masterlistType: masterlistType,
        hasData: data && data.length > 0,
        showFilterBox,
        handleFilterClick,
        filterAvailable: facets && facets.length > 0
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sort, filterOptions, data, handleCheckboxChange, setApply, showFilterBox]);

  return (
    <>
    {!isLoading ? (
    <Stack>
      <GridView
        handleDrawer={handleItemNavigation}
        masterlistType={masterlistType}
        fetchMoreData={fetchMoreData}
        data={data}
        filterPills={filterPills}
        setFilterPills={setFilterPills}
        showFilterBox={showFilterBox}
        handleFilterClick={handleFilterClick}
        hasMore={hasMore}
        setShowFilterBox={setShowFilterBox}
        setApply={setApply}
        sort={sort}
        handleCheckboxChange={handleCheckboxChange}
        handleSearch={handleSearch}
        filterOptions={filterOptions}
        filteroptionData={facets}
        setFilterOptions={setFilterOptions}
        setSearchTerm={setSearchTerm}
        filterCount={filterCount}
        searchTerm={searchTerm}
        handleReset={handleReset}
        filterbuttonStyle={filterbuttonStyle}
        filteredResultCount={filteredResultCount}
      />
    </Stack>):
    (
      <HStack justifyContent={"center"} minH={"100vh"} alignItems={"flex-start"} mt={4}>
          <Image src={loaderImg} width={"100px"} height={"100px"} alt="Loading" />
      </HStack>
    )
  }
    </>
  );
};

